import React from "react";

const Footer = () => {
  return (
    <>
      <footer>
        <div className="footer-inner">
          <div className="footer-center">
            Made by{" "}
            <a
              href="https://thehardik.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
              theHardik
            </a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
